import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import DateRange from 'components/Form/DateRange';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import { LegalAssociationsEventItemModel } from 'forms/sections/legal/associations/eventItem/types';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import {
  CommonOnError,
  CommonOnUpdate,
  CommonRequired,
  CommonScrollIntoView,
} from '../../../../types/props';

interface Props
  extends Partial<LegalAssociationsEventItemModel>,
  ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  scrollIntoView?: CommonScrollIntoView
}

export default class EventItem extends ValidationElement<Props> {
  update = (queue: Partial<LegalAssociationsEventItemModel>) => {
    this.props.onUpdate({
      Why: this.props.Why,
      What: this.props.What,
      When: this.props.When,
      ...queue
    });
  };

  updateWhy = (values: LegalAssociationsEventItemModel['Why']) => {
    this.update({
      Why: values,
    });
  };

  updateWhat = (values: LegalAssociationsEventItemModel['What']) => {
    this.update({
      What: values,
    });
  };

  updateWhen = (values: LegalAssociationsEventItemModel['When']) => {
    this.update({
      When: values,
    });
  };

  render() {
    const {
      subSectionAssetPath,
      subSectionClassName,
      hasWhy,
      hasWhen,
      hasWhat,
    } = this.props;

    const attribute = `${this.props.attribute}.items[${this.props.$index}].Item`;
    return (
      <div>

        {hasWhat && (
          <Field
            key={`${attribute}.What`}
            title={i18n.t(`${subSectionAssetPath}.What`)}
            adjustFor="textarea"
            attribute={`${attribute}.What`}
            scrollIntoView={this.props.scrollIntoView}
          >
            <Textarea
              name="What"
              attribute={`${attribute}.What`}
              {...this.props.What}
              onUpdate={this.updateWhat}
              onError={this.props.onError}
              className={`${subSectionClassName}-What`}
              required={this.props.required}
            />
          </Field>
        )}
        {hasWhy && (
          <Field
            key={`${attribute}.Why`}
            title={i18n.t(`${subSectionAssetPath}.Why`)}
            adjustFor="textarea"
            attribute={`${attribute}.Why`}
            scrollIntoView={this.props.scrollIntoView}
          >
            <Textarea
              name="Why"
              attribute={`${attribute}.Why`}
              {...this.props.Why}
              onUpdate={this.updateWhy}
              onError={this.props.onError}
              className={`${subSectionClassName}-Why`}
              required={this.props.required}
            />
          </Field>
        )}

        {hasWhen && (
          <Field
            key={`${attribute}.When`}
            title={i18n.t(`${subSectionAssetPath}.When`)}
            help={`${subSectionAssetPath}.help.when`}
            adjustFor="daterange"
            attribute={`${attribute}.When`}
            scrollIntoView={this.props.scrollIntoView}
          >
            <DateRange
              name="Dates"
              attribute={`${attribute}.When`}
              {...this.props.When}
              minDateEqualTo
              onUpdate={this.updateWhen}
              onError={this.props.onError}
              className={`${subSectionClassName}-When`}
              required={this.props.required}
              hideFromDay
              hideToDay
            />
          </Field>

        )}

      </div>
    );
  }
}

EventItem.defaultProps = {
  Why: {},
  When: {},
  What: {},
  hasWhy: false,
  hasWhen: false,
  hasWhat: false,
  questionLayout: [],
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};
